// Libraries
import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';

// Enums
import { ResultsSummaryType } from 'engagementReport/enums/propTypes';

// Components
import ResultsSummarySidebar from './ResultsSummarySidebar';
import ResultsSummaryFooter from './ResultsSummaryFooter';
import SinglePageDisplay from './SinglePageDisplay';
import MultiPagesDisplay from './MultiPagesDisplay';
import ResultsSummaryIntroduction from './ResultsSummaryIntroduction';
import ResultsSummaryConclusion from './ResultsSummaryConclusion';

const ResultsSummary = ({ resultsSummary, projectStatus, projectHubEnabled }) => {
  const { introduction, conclusion, sections, engagementSummary, createdAt } = resultsSummary;
  const sectionsToRender = sections.filter((section) => section.questions.length);
  const [multiPagesDisplay, setMultiPagesDisplay] = useState(false);

  return (
    <div className="results-summary">
      <div className="container inner">
        <div className="columns">
          <div className="column is-three-quarters">
            {multiPagesDisplay ? (
              <MultiPagesDisplay
                sections={sectionsToRender}
                engagementSummary={engagementSummary}
                createdAt={createdAt}
                introduction={
                  introduction ? (
                    <ResultsSummaryIntroduction
                      introduction={introduction}
                      multiPagesDisplay={multiPagesDisplay}
                    />
                  ) : null
                }
                conclusion={
                  conclusion ? (
                    <ResultsSummaryConclusion
                      conclusion={conclusion}
                      multiPagesDisplay={multiPagesDisplay}
                    />
                  ) : null
                }
              />
            ) : (
              <SinglePageDisplay
                sections={sectionsToRender}
                engagementSummary={engagementSummary}
                createdAt={createdAt}
                introduction={
                  <ResultsSummaryIntroduction
                    introduction={introduction}
                    multiPagesDisplay={multiPagesDisplay}
                  />
                }
                conclusion={
                  <ResultsSummaryConclusion
                    conclusion={conclusion}
                    multiPagesDisplay={multiPagesDisplay}
                  />
                }
              />
            )}

            <ResultsSummaryFooter
              resultsSummary={resultsSummary}
              multiPagesDisplay={multiPagesDisplay}
            />
          </div>

          <div className="column is-one-quarter is-hidden-mobile">
            <ResultsSummarySidebar
              resultsSummary={resultsSummary}
              projectStatus={projectStatus}
              projectHubEnabled={projectHubEnabled}
              multiPages={multiPagesDisplay}
              onDisplayToggle={() => setMultiPagesDisplay(!multiPagesDisplay)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ResultsSummary.propTypes = {
  resultsSummary: ResultsSummaryType.isRequired,
  projectStatus: PropTypes.string,
  projectHubEnabled: PropTypes.bool.isRequired,
};

ResultsSummary.defaultProps = {
  projectStatus: '',
};

export default memo(ResultsSummary);
